import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function UserCheck({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M4 20C4 17.51 6.01 15.5 8.5 15.5H11.083M19 16.938L16 19.938L14.2 18.138M12 4C11.4419 4 10.8892 4.10993 10.3736 4.32351C9.85796 4.53709 9.38944 4.85015 8.9948 5.2448C8.60015 5.63945 8.28709 6.10796 8.07351 6.6236C7.85993 7.13923 7.75 7.69188 7.75 8.25C7.75 8.80812 7.85993 9.36077 8.07351 9.8764C8.28709 10.392 8.60015 10.8606 8.9948 11.2552C9.38944 11.6499 9.85796 11.9629 10.3736 12.1765C10.8892 12.3901 11.4419 12.5 12 12.5C12.5581 12.5 13.1108 12.3901 13.6264 12.1765C14.142 11.9629 14.6106 11.6499 15.0052 11.2552C15.3999 10.8606 15.7129 10.392 15.9265 9.8764C16.1401 9.36077 16.25 8.80812 16.25 8.25C16.25 7.69188 16.1401 7.13923 15.9265 6.6236C15.7129 6.10796 15.3999 5.63945 15.0052 5.2448C14.6106 4.85015 14.142 4.53709 13.6264 4.32351C13.1108 4.10993 12.5581 4 12 4Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default UserCheck;